import { BASE_URL, VENDOR_ASSESSMENT_DEFINITION } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { IVendorAssessmentDefinition, IVendorAssessmentDefinitionInput } from "models/vendorAssessmentDefinition";


export async function getVendorAssessmentDefinitions(params: string = ""):Promise<IVendorAssessmentDefinition[]> {
  const response = await axios.get(BASE_URL + VENDOR_ASSESSMENT_DEFINITION + params);
  return response.data;
}

export async function getVendorAssessmentDefinitionById(id: string):Promise<IVendorAssessmentDefinition> {
  const response = await axios.get(BASE_URL + VENDOR_ASSESSMENT_DEFINITION + "/" + id);
  return response.data;
}

export async function addVendorAssessmentDefinition(data: IVendorAssessmentDefinitionInput) {
  const response = await axios.post(BASE_URL + VENDOR_ASSESSMENT_DEFINITION, data);
  return response.data;
}

export async function editVendorAssessmentDefinition(data: IVendorAssessmentDefinitionInput, id: string) {
  const response = await axios.patch(BASE_URL + VENDOR_ASSESSMENT_DEFINITION + "/" + id, data);
  return response.data;
}

export async function deleteVendorAssessmentDefinition(id: string) {
  const response = await axios.delete(BASE_URL + VENDOR_ASSESSMENT_DEFINITION + "/" + id);
  return response.data;
}

export async function cloneVendorAssessmentDefinition(id: string) {
  const response = await axios.post(BASE_URL + VENDOR_ASSESSMENT_DEFINITION + '/clone?definitionId=' + id);
  return response.data;
}

export async function getWorkshopsByAssessment(id: string) {
  const response = await axios.get(BASE_URL + VENDOR_ASSESSMENT_DEFINITION + '/' + id + '/workshops');
  return response.data;
}

export const VendorAssessmentDefinitionCells: HeadCell[] = [
  {
    id: "internalId",
    numeric: true,
    disablePadding: false,
    label: "T_internal_id",
  },
  {
    id: "title",
    numeric: false,
    disablePadding: false,
    label: "T_title",
  },
  {
    id: "titleAr",
    numeric: false,
    disablePadding: false,
    label: "T_title_ar",
  },
  {
    id: "assessmentLevel",
    numeric: false,
    disablePadding: false,
    label: "T_assessment_level",
  },
  {
    id: "numberOfQuestions",
    numeric: false,
    disablePadding: false,
    label: "T_number_of_questions",
  },
  {
    id: "numberOfWorkshops",
    numeric: false,
    disablePadding: false,
    label: "T_number_workshops",
  },
  {
    id: "companyId",
    numeric: false,
    disablePadding: false,
    label: "T_company",
  },
  {
    id: "certifyingBodyId",
    numeric: false,
    disablePadding: false,
    label: "T_certifying_body",
  },
  {
    id: "createdOn",
    numeric: false,
    disablePadding: false,
    label: "T_created_date",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
